import { render, staticRenderFns } from "./events_tasks.vue?vue&type=template&id=21e420a6&scoped=true"
import script from "./events_tasks.vue?vue&type=script&lang=js"
export * from "./events_tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e420a6",
  null
  
)

export default component.exports